import IVideoOptions from '../../typings/IVideoOptions'
import Logger from '../helpers/Logger'

// Finds all mediavine video scripts, and inserts a targetDiv
// next to it if one doesn't already exist.
export function insertMissingOptionDivs(): void {
  const allVideoScripts = getMediavineVideoScripts()
  allVideoScripts.forEach((videoScript) => {
    // findTargetDivIdFromScript() will return the ID that the target div should be
    // even if it doesn't exist.
    const optionsDivId = findTargetDivIdFromScript(videoScript)
    let optionsDiv = findTargetDivFromScript(videoScript)
    const videoOptions: IVideoOptions =
      window[videoScript.getAttribute('data-options') || '']

    if (!optionsDiv && !videoOptions) {
      optionsDiv = document.createElement('div')
      optionsDiv.id = optionsDivId
      videoScript.insertAdjacentElement('beforebegin', optionsDiv)
      Logger.debug('Video: optionsDiv NOT found.  ADDING ONE!', optionsDivId)
    }
  })
}

/**
 * Given a mediavine video script element, this returns the <script>'s id of the options div that matches the script
 * @param videoScript - Mediavine video <script>
 */
export function findTargetDivIdFromScript(
  videoScript: HTMLScriptElement
): string {
  let scriptSlug

  const scriptSrc = videoScript.getAttribute('src') || ''

  // Extract the slug from the script's src attribute.
  // const slugMatches = scriptSrc.match(/\/videos\/([\w]+)\.js/)
  const slugMatches = scriptSrc.match(
    /\/(?:videos|playlists\/(?:.+?))\/([\w-]+)\.js/
  )
  if (slugMatches && slugMatches[1]) {
    scriptSlug = slugMatches[1]
  }

  let optionsDivId
  if (scriptSrc.indexOf('/playlists/') !== -1) {
    optionsDivId = `mediavine-playlist-${scriptSlug}`
  } else {
    optionsDivId = scriptSlug
  }

  return optionsDivId
}

export function findTargetDivFromScript(
  videoScript: HTMLScriptElement
): HTMLDivElement | null {
  const targetDivId = findTargetDivIdFromScript(videoScript)
  return document.getElementById(targetDivId) as HTMLDivElement
}

export function getMediavineVideoScripts(): Array<HTMLScriptElement> {
  const selectors = [
    `script[src*='scripts.mediavine.com/videos/']`,
    `script[src*='video.mediavine.com/videos/']`,
    `script[src*='video-staging.mediavine.com/videos/']`,
    `script[src*='localhost:3030/videos/']`,
    `script[src*='scripts.mediavine.com/playlists/']`,
    `script[src*='video.mediavine.com/playlists/']`,
    `script[src*='video-staging.mediavine.com/playlists/']`,
    `script[src*='localhost:3030/playlists/']`
  ].join(',')
  const scripts = document.querySelectorAll(selectors) as NodeListOf<
    HTMLScriptElement
  >

  // if we can find the slug from the script, it's a video script!
  return Array.from(scripts).filter(
    (script) => !!findTargetDivIdFromScript(script)
  )
}
